export default "__VITE_PUBLIC_ASSET__9d75bd3d__"